module.exports = __webpack_public_path__ + "static/checkup2-a637984b4300e1651da54b7dcbc3b895.png";